module.exports = __webpack_public_path__ + "static/media/4_Nova.20cc2efb.png";